// ** Next
import Link from "next/link";

// ** MUI
import { Box, Card, CardContent, Typography } from "@mui/material";

function TagCard({ tags }) {
  return (
    <Card
      spacing={3}
      sx={{ borderRadius: "15px", marginTop: "34px", marginBottom: "14px" }}
    >
      <CardContent>
        <Box
          component={"ul"}
          sx={{
            display: "flex",
            flexWrap: "wrap",
            maxHeight: "250px", // height limit
            overflowY: "auto", // vertical scroll
            padding: "0px",
            paddingRight: "5px", // so scrollbar does not overlap content
          }}
        >
          {tags?.map((tag) => (
            <Box
              component={"li"}
              sx={{ listStyle: "none" }}
              key={tag.documentId}
            >
              <Box
                component={Link}
                href={`/blog/tag/${tag.slug}`}
                sx={{
                  backgroundColor: "#EDF2F7",
                  padding: "5px 15px",
                  borderRadius: "5px",
                  display: "inline-flex",
                  justifyContent: "center",
                  marginBottom: "5px",
                  marginTop: "5px",
                  marginRight: "5px",
                  cursor: "pointer",
                  textDecoration: "none",
                  color: "#7F8DA1",
                  "&:hover": {
                    color: "#ffffff",
                    backgroundColor: "#718096",
                  },
                }}
              >
                <Typography sx={{ fontWeight: 600, fontSize: "12px" }}>
                  # {tag.name}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}

export default TagCard;
